import { render } from "./SendPicturesForm.vue?vue&type=template&id=1018da9d&scoped=true"
import script from "./SendPicturesForm.vue?vue&type=script&lang=js"
export * from "./SendPicturesForm.vue?vue&type=script&lang=js"

import "./SendPicturesForm.vue?vue&type=style&index=0&id=1018da9d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1018da9d"

export default script